export default "__VITE_ASSET__25cc2e0e__"